import React, { useState } from "react";
import { useNotifications } from "./NotificationContext";
import NativeWebSocketService from "./nativeWebSocketService";
import "./NotificationBell.css";

const NotificationBell = () => {
  const { notifications, removeNotification, clearNotifications, isConnected } =
    useNotifications();
  const [isOpen, setIsOpen] = useState(false);

  const unreadCount = notifications.length;

  const handleBellClick = () => {
    setIsOpen(!isOpen);
  };

  const handleNotificationClick = (notification) => {
    if (notification.orderId) {
      window.dispatchEvent(new CustomEvent("selectAdminOrder", { detail: { orderId: notification.orderId } }));
    }
    removeNotification(notification.id);
    setIsOpen(false);
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case "new_order":
        return "🆕";
      case "order_update":
        return "📝";
      default:
        return "🔔";
    }
  };

  return (
    <div className="notification-bell">
      {/* Connection Status Indicator */}
      <div
        className={`connection-status ${
          isConnected ? "connected" : "disconnected"
        }`}
      >
        {isConnected ? "🔵" : "🔴"}
      </div>

      {/* Bell Icon */}
      <div className="bell-container" onClick={handleBellClick}>
        <div className="bell-icon">
          🔔
          {unreadCount > 0 && (
            <span className="notification-count">{unreadCount}</span>
          )}
        </div>
      </div>

      {/* Dropdown Notifications */}
      {isOpen && (
        <div className="notification-dropdown">
          <div className="notification-header">
            <h3>Notifications</h3>
            <div className="header-actions">
              <button
                type="button"
                className="notif-header-btn test-sound-btn"
                onClick={() => NativeWebSocketService.playNotificationSound()}
                title="Test Chime Sound"
              >
                🔔 Test Sound
              </button>
              {notifications.length > 0 && (
                <button
                  type="button"
                  className="notif-header-btn clear-all-btn"
                  onClick={clearNotifications}
                  title="Clear all notifications"
                >
                  Clear All
                </button>
              )}
              <button
                type="button"
                className="notif-close-btn"
                onClick={() => setIsOpen(false)}
                title="Close"
              >
                ✕
              </button>
            </div>
          </div>

          <div className="notification-list">
            {notifications.length === 0 ? (
              <div className="empty-notifications">No new notifications</div>
            ) : (
              notifications.map((notification) => (
                <div
                  key={notification.id}
                  className={`notification-item ${notification.type}`}
                  onClick={() => handleNotificationClick(notification)}
                >
                  <div className="notification-icon">
                    {getNotificationIcon(notification.type)}
                  </div>
                  <div className="notification-content">
                    <div className="notification-title">
                      {notification.title}
                    </div>
                    <div className="notification-message">
                      {notification.message}
                    </div>
                    {notification.amount && (
                      <div className="notification-amount">
                        ₹{notification.amount}
                      </div>
                    )}
                    <div className="notification-time">
                      {notification.timestamp}
                    </div>
                  </div>
                  <button
                    className="remove-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeNotification(notification.id);
                    }}
                  >
                    ✕
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
